import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProfileReport, IDropdownItem } from "../../../types/reportprofile";

/**
 * 📊 Estado global de reportes por perfil
 *
 * - `reports`: lista de reportes asociados a un perfil (habilitados o no)
 * - `dropdownReports`: lista global para dropdowns de configuración
 */
export interface IProfileReportState {
  reports: IProfileReport[];
  dropdownReports: IDropdownItem[];
}

/** 🧱 Estado inicial */
export const initialState: IProfileReportState = {
  reports: [],
  dropdownReports: [],
};

export const profileReportSlice = createSlice({
  name: "profileReport",
  initialState,
  reducers: {
    // =====================================================
    // 🌐 CONSULTAS BASE
    // =====================================================

    /** Cargar los reportes asociados a un perfil */
    setReportsByProfile: (state, action: PayloadAction<IProfileReport[]>) => {
      state.reports = action.payload;
    },

    /** Cargar los reportes globales (dropdown) */
    setDropdownReports: (state, action: PayloadAction<IDropdownItem[]>) => {
      state.dropdownReports = action.payload;
    },

    /** Reiniciar todo el estado */
    resetProfileReportState: () => initialState,

    // =====================================================
    // 🎯 ACTUALIZACIONES (toggle habilitado/deshabilitado)
    // =====================================================

    /** Actualizar el estado habilitado de un reporte específico */
    toggleReportStatus: (
      state,
      action: PayloadAction<{ reportId: number; enabled: boolean }>
    ) => {
      const { reportId, enabled } = action.payload;
      const target = state.reports.find((r) => r.reportId === reportId);
      if (target) {
        target.enabled = enabled;
      }
    },
  },
});

// =====================================================
// 📤 EXPORTAR ACTIONS
// =====================================================
export const {
  setReportsByProfile,
  setDropdownReports,
  resetProfileReportState,
  toggleReportStatus,
} = profileReportSlice.actions;

// =====================================================
// 📤 EXPORTAR REDUCER
// =====================================================
export default profileReportSlice.reducer;
